import Gfooter from "../Component/Gfooter"
export default function Flooring(){
  return(
    <div className="read-top">
      <div className="container">
        <h1 className="our-heading">
          <strong>Our Offerings</strong>
        </h1>
      </div>

   

      {/* 3. Designer Flooring Solutions */}
      <div className="container">
        <h2 className="productmore-heading">
          <strong>Designer Flooring Solutions</strong>
        </h2>
      </div>
      <div className="container product-all">
        <div className="row">
          <div className="productmore-detail col-lg-6 col-md-12 col-sm-12" data-aos="zoom-in" data-aos-delay="100">
            <div className="productmore-info">
              <img src="project-pic/Floor.jpg" alt="Designer Flooring" />
              <div className="productmore-content">
                <h2 className="key-title"><strong>Key Features:</strong></h2>
                <ul>
                  <li><p><b>Material Variety:</b> Includes wooden flooring, vinyl, carpet tiles, marble, epoxy, and stone finishes.</p></li>
                  <li><p><b>Slip Resistance:</b> Options available with anti-slip coatings for enhanced safety.</p></li>
                  <li><p><b>Seamless Finishes:</b> Impeccable surface quality that elevates any interior.</p></li>
                  <li><p><b>Moisture & Wear Resistant:</b> Ideal for high-traffic and spill-prone areas.</p></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="benefits col-lg-6 col-md-12 col-sm-12">
            <h2 className="benefits-title"><strong>Benefits:</strong></h2>
            <ul>
              <li><p><b>Durability:</b> Built to last under heavy footfall and harsh conditions.</p></li>
              <li><p><b>Aesthetic Harmony:</b> Adds texture, warmth, and style to interiors.</p></li>
              <li><p><b>Easy Maintenance:</b> Low upkeep with easy-to-clean surfaces.</p></li>
              <li><p><b>Design Versatility:</b> Custom colors, patterns, and borders available.</p></li>
            </ul>
          </div>
        </div>
      </div>

    

      {/* Closing */}
      <div className="container para-bottom">
        <p>
          NLG Furniture brings you comprehensive, future-ready interior and architectural solutions—from top-tier roofing to ergonomic, modular interiors. Experience the perfect blend of innovation, aesthetics, and engineering.
        </p>
      </div>

      <Gfooter />
    </div>
  )
}